function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import PropTypes from 'prop-types';
import Dialog from './dialog';
import ConfigProvider from '../config-provider';
import Button from '../button';

var noop = function noop() {};

var StepDialog = /*#__PURE__*/function (_React$Component) {
  _inherits(StepDialog, _React$Component);

  var _super = _createSuper(StepDialog);

  function StepDialog(props) {
    var _this;

    _classCallCheck(this, StepDialog);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "onStepChange", function (current) {
      if (!('current' in _this.props)) {
        _this.setState({
          current: current
        });
      }

      _this.props.onStepChange(current);
    });

    _defineProperty(_assertThisInitialized(_this), "getViewMeta", function () {
      var children = _this.props.children;
      var meta = [];
      React.Children.forEach(children, function (c) {
        if (c) {
          meta.push({
            id: c.props.id,
            title: c.props.title,
            footer: c.props.footer
          });
        }
      });
      return meta;
    });

    _defineProperty(_assertThisInitialized(_this), "checkView", function () {
      var children = _this.props.children;
      var isView = true;

      if (children === null) {
        return false;
      }

      React.Children.forEach(children, function (c) {
        if (c && c.type && c.type.displayName !== 'StepView') {
          isView = false;
        }
      });
      return isView;
    });

    _this.state = {
      current: props.current || props.defaultCurrent
    };
    return _this;
  }

  _createClass(StepDialog, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      if (nextProps.current !== this.props.current) {
        this.setState({
          current: nextProps.current
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      if (!this.checkView()) {
        return null;
      }

      var _this$props = this.props,
          children = _this$props.children,
          prefix = _this$props.prefix;
      var metas = this.getViewMeta();
      var current = this.state.current;
      var meta = metas.find(function (m) {
        return m.id === current;
      }) || {};
      var index = metas.findIndex(function (m) {
        return m.id === current;
      });
      var child = React.Children.toArray(children).find(function (c) {
        return c.props.id === current;
      });
      var title = index === 0 ? /*#__PURE__*/React.createElement("span", null, meta.title) :
      /*#__PURE__*/

      /* eslint no-script-url: 1 */
      React.createElement("span", null, /*#__PURE__*/React.createElement("a", {
        role: "button",
        href: "javascript:;",
        className: "".concat(prefix, "dialog-prev")
      }, /*#__PURE__*/React.createElement(Button.Icon, {
        name: "chevron-left",
        type: "primary",
        color: "gray",
        onClick: this.onStepChange.bind(this, metas[index - 1].id)
      })), /*#__PURE__*/React.createElement("span", null, meta.title));
      return /*#__PURE__*/React.createElement(Dialog, _extends({}, this.props, {
        title: title,
        footer: meta.footer
      }), child);
    }
  }]);

  return StepDialog;
}(React.Component);

_defineProperty(StepDialog, "propTypes", {
  prefix: PropTypes.string,
  rtl: PropTypes.bool,
  className: PropTypes.string,

  /**
   * 是否显示
   */
  visible: PropTypes.bool,

  /**
   * 内容
   */
  children: PropTypes.node,

  /**
   * 应用于取消按钮的属性对象
   */
  cancelProps: PropTypes.object,

  /**
   * 控制对话框关闭的方式，值可以为字符串或者布尔值，其中字符串是由以下值组成：
   * **close** 表示点击关闭按钮可以关闭对话框
   * **mask** 表示点击遮罩区域可以关闭对话框
   * **esc** 表示按下 esc 键可以关闭对话框
   * 如 'close' 或 'close,esc,mask'
   * 如果设置为 true，则以上关闭方式全部生效
   * 如果设置为 false，则以上关闭方式全部失效
   */
  closeable: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),

  /**
   * 对话框关闭时触发的回调函数
   * @param {String} trigger 关闭触发行为的描述字符串
   * @param {Object} event 关闭时事件对象
   */
  onClose: PropTypes.func,

  /**
   * 对话框关闭后触发的回调函数, 如果有动画，则在动画结束后触发
   */
  afterClose: PropTypes.func,

  /**
   * 是否显示遮罩
   */
  hasMask: PropTypes.bool,

  /**
   * 显示隐藏时动画的播放方式
   * @property {String} in 进场动画
   * @property {String} out 出场动画
   */
  animation: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),

  /**
   * 对话框弹出时是否自动获得焦点
   */
  autoFocus: PropTypes.bool,

  /**
   * 对话框对齐方式, 具体见Overlay文档
   */
  align: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),

  /**
   * 当对话框高度超过浏览器视口高度时，是否显示所有内容而不是出现滚动条以保证对话框完整显示在浏览器视口内，该属性仅在对话框垂直水平居中时生效，即 align 被设置为 'cc cc' 时
   */
  isFullScreen: PropTypes.bool,

  /**
   * 是否在对话框重新渲染时及时更新对话框位置，一般用于对话框高度变化后依然能保证原来的对齐方式
   */
  shouldUpdatePosition: PropTypes.bool,

  /**
   * 对话框距离浏览器顶部和底部的最小间距，align 被设置为 'cc cc' 并且 isFullScreen 被设置为 true 时不生效
   */
  minMargin: PropTypes.number,

  /**
   * 透传到弹层组件的属性对象
   */
  overlayProps: PropTypes.object,

  /**
   * 对话框的高度样式属性
   */
  height: PropTypes.string,

  /**
   * 没有内容区的padding
   */
  noBodyPadding: PropTypes.bool,

  /**
   * 当前步骤屏id，受控
   */
  current: PropTypes.string,

  /**
   * 默认步骤屏id，非受控
   */
  defaultCurrent: PropTypes.string,

  /**
   * 步骤屏发生变化时的回调
   */
  onStepChange: PropTypes.func,

  /**
   * 是否处于加载状态
   */
  loading: PropTypes.bool,

  /**
   * 加载内容
   */
  loadingTip: PropTypes.node
});

_defineProperty(StepDialog, "defaultProps", {
  prefix: 'next-',
  visible: false,
  closeable: 'esc,close',
  onClose: noop,
  afterClose: noop,
  hasMask: true,
  animation: {
    "in": 'fadeInDown',
    out: 'fadeOutUp'
  },
  autoFocus: false,
  align: 'cc cc',
  isFullScreen: false,
  shouldUpdatePosition: false,
  minMargin: 40,
  overlayProps: {},
  noBodyPadding: false,
  onStepChange: noop,
  loading: false
});

export default ConfigProvider.config(StepDialog);